
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StsPortalStatus } from '../models/sts-portal-status';
import { StsHttpService } from './sts-http.service';

@Injectable()
export class StsPortalStatusService {

  constructor(private stsHttp: StsHttpService) {
  }

  public getPortalStatus(): Observable<StsPortalStatus> {
    return this.stsHttp.get<StsPortalStatus>('/api/checkPortalStatus').pipe(
      map((res) => {
        let portalStatus: StsPortalStatus = {
          isLoggedIn: res.isLoggedIn,
          isSelfRegFlow: res.isSelfRegFlow,
          isMemberPortal: res.isMemberPortal,
          isInRecoveryMode: res.isInRecoveryMode,
          answersProvided: res.answersProvided,
          tfaReference: res.tfaReference,
          lastUnverifiedTfaEmail: res.lastUnverifiedTfaEmail,
          tfa: res.tfa
        };
        return portalStatus;
      }),
      catchError((error: any) => {
        console.log('Error getting /api/checkPortalStatus => ' + error);
        return throwError(error || 'Server error');
      })
    );
  }

}
